import(/* webpackMode: "eager" */ "/app/src/app/shop/page.jsx")